var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { API } from './api';
import { AssetProvider } from './asset';
import { BaseProvider } from './base';
import { BrainVersionType } from './brain';
var MAX_FRAMES_TO_RETURN = 9999;
var RecognitionFrame = /** @class */ (function () {
    function RecognitionFrame() {
    }
    return RecognitionFrame;
}());
export { RecognitionFrame };
var FrameProvider = /** @class */ (function (_super) {
    __extends(FrameProvider, _super);
    function FrameProvider(api, assetProvider) {
        var _this = _super.call(this) || this;
        _this.api = api;
        _this.assetProvider = assetProvider;
        return _this;
    }
    FrameProvider.prototype.getValidationRecognitionFrames = function (id, offset, limit, brainVersionType) {
        if (offset === void 0) { offset = 0; }
        if (limit === void 0) { limit = 9999; }
        if (brainVersionType === void 0) { brainVersionType = BrainVersionType.Learning; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "datasets/" + id + "/validation-frames?offset=" + offset + "&limit=" + limit + "&brainVersionType=" + brainVersionType;
                        return [4 /*yield*/, this.debounce(url, function () {
                                return _this.api.get(url);
                            }, 250)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.validationFrames];
                }
            });
        });
    };
    FrameProvider.prototype.getTestRecognitionFrames = function (datasetIdentifier, offset, limit) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "datasets/" + datasetIdentifier + "/test-set/recognition-frames?offset=" + (offset || 0) + "&limit=" + (limit ||
                            MAX_FRAMES_TO_RETURN);
                        return [4 /*yield*/, this.debounce(url, function () {
                                return _this.api.get(url);
                            }, 250)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.message.testAssetResults];
                }
            });
        });
    };
    FrameProvider.prototype.getTestRecognitionFrameDetail = function (datasetIdentifier, testAssetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "datasets/" + datasetIdentifier + "/test-set/recognition-frames/" + testAssetIdentifier;
                        return [4 /*yield*/, this.debounce(url, function () {
                                return _this.api.get(url);
                            }, 250)];
                    case 1:
                        response = _a.sent();
                        if (response.success && response.message) {
                            return [2 /*return*/, this.assetProvider.convertAssetResponseObjectToTaggableAsset(response.message)];
                        }
                        else {
                            throw new Error("No test asset found with identifier: " + testAssetIdentifier);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FrameProvider.prototype.getValidationDetectionFramesResponse = function (id, offset, limit, groundTruthClass, predictionClass) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var url, response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "datasets/" + id + "/detection-validation-frames?offset=" + offset + "&limit=" + limit;
                        if (groundTruthClass) {
                            url += "&groundTruthClass=" + groundTruthClass;
                        }
                        if (predictionClass) {
                            url += "&predictionClass=" + predictionClass;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.debounce(url, function () {
                                return _this.api.get(url);
                            }, 250)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, {
                                total: response.total,
                                validationFrames: response.validationFrames
                            }];
                    case 3:
                        err_1 = _a.sent();
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FrameProvider.prototype.getValidationDetectionFrameDetail = function (datasetIdentifier, assetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.get("datasets/" + datasetIdentifier + "/detection-validation-frames/" + assetIdentifier)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FrameProvider.prototype.getTestDetectionFrames = function (datasetIdentifier, limit, offset, groundTruthClass, predictionClass) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTestDetectionFramesResponse(datasetIdentifier, offset, limit, groundTruthClass, predictionClass)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.validationFrames];
                }
            });
        });
    };
    FrameProvider.prototype.getTestDetectionFramesResponse = function (datasetIdentifier, offset, limit, groundTruthClass, predictionClass) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "datasets/" + datasetIdentifier + "/test-set/detection-frames?offset=" + (offset || 0) + "&limit=" + (limit ||
                            MAX_FRAMES_TO_RETURN);
                        if (groundTruthClass) {
                            url += "&groundTruthClass=" + groundTruthClass;
                        }
                        if (predictionClass) {
                            url += "&predictionClass=" + predictionClass;
                        }
                        return [4 /*yield*/, this.debounce(url, function () {
                                return _this.api.get(url);
                            }, 250)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, {
                                total: response.message.total,
                                validationFrames: response.message.testAssetResults
                            }];
                }
            });
        });
    };
    FrameProvider.prototype.getTestDetectionFrameDetail = function (datasetIdentifier, assetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.get("datasets/" + datasetIdentifier + "/test-set/detection-frames/" + assetIdentifier)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FrameProvider.prototype.getDetectionFrameDetail = function (datasetIdentifier, assetIdentifier, isTestSet) {
        if (isTestSet === void 0) { isTestSet = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isTestSet) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getTestDetectionFrameDetail(datasetIdentifier, assetIdentifier)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.getValidationDetectionFrameDetail(datasetIdentifier, assetIdentifier)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FrameProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API, AssetProvider])
    ], FrameProvider);
    return FrameProvider;
}(BaseProvider));
export { FrameProvider };
//# sourceMappingURL=frame.js.map


// WEBPACK FOOTER //
// ./src/providers/frame.ts.pre-build-optimizer.js